
var $jq = jQuery.noConflict();

$jq(function () {
  //console.log('ok');

  $jq('.blog-carrossel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    /* speed: 500, */
    dots: true,
    arrows: true,
    //centerMode: true,
    fade: true,
    /* autoplay: true,
    autoplaySpeed: 8000, */
  });

  $jq('.faixa').slick({
    infinite: true,
    slidesToShow: 9,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 7
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2
      }
    }
    ]
  });

  $jq('.lista-produtos-home').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    pauseOnHover: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $jq('.lista-cases-home').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: false,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $jq('.lista-posts').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true,
    responsive: [{
      breakpoint: 3,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  /* Carrossel 6 */
  $jq('.carrossel-6').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true,
    responsive: [{
      breakpoint: 3,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  /* Carrossel 4 */
  $jq('.carrossel-4').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 3,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  /* Carrossel 3 */
  $jq('.carrossel-3').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true,
    responsive: [{
      breakpoint: 993,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  /* Carrossel 2 */
  $jq('.carrossel-2').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true,
    responsive: [{
      breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  /* Carrossel 1 */
  $jq('.carrossel-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    dots: true,
    arrows: true
  });

  /* Produtos em destaque (home) */
  $jq('.fma-produtos-carrossel').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    dots: false,
    arrows: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '12%',
        arrows: false
      }
    }]
  });

});
